
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { ThemeProvider } from './components/theme/ThemeProvider.tsx';

createRoot(document.getElementById("root")!).render(
  <ThemeProvider defaultTheme="light" storageKey="royalty-theme-mode">
    <App />
  </ThemeProvider>
);
